import React from "react";
import { publication_data } from "../../data/data";

function Publications() {
  return (
    <section className="home-header publications">
      <h1 className="heading-name">Publications</h1>
      <ul className="publication-list">
        {publication_data.map((pub) => (
          <li key={pub.id} className="publication-item">
            <a
              href={pub.link}
              target="_blank"
              rel="noopener noreferrer"
              className="publication-link"
            >
              {pub.title}
            </a>
            <span className="publication-authors">
              {pub.authors.split(", ").map((author, idx) => (
                <React.Fragment key={idx}>
                  {idx > 0 && ", "}
                  {author === "Te-Yen Chou" ? (
                    <strong>{author}</strong>
                  ) : (
                    author
                  )}
                </React.Fragment>
              ))}
            </span>
            <span className="publication-venue"> ({pub.venue})</span>
          </li>
        ))}
      </ul>
    </section>
  );
}

export default Publications;
